import { transparentize } from 'polished'
import { th, css, theme } from '@smooth-ui/core-sc'

export default {
  ...theme,
  // Colors
  primary: '#366CFE',
  secondary: '#695996',
  universe: '#fff8e7',
  green: '#31bd13',
  gray100: '#f4f6f7',
  gray1000: '#18192D',
  gray1100: '#000020',
  // Input & Button
  inputBtnPaddingY: '.425rem',
  inputBtnPaddingX: '.875rem',
  inputTextColor: th('gray1000'),
  inputPlaceholderText: th('gray500'),
  controlFocus: props => (baseColor = 'primary') => css`
    outline: 0;
    box-shadow: 0 0 0 0.2rem
      ${th(baseColor, color => transparentize(0.75, color))};
  `,
  // Typography
  fontSizes: [
    '.75rem',
    '.875rem',
    '1rem',
    '1.25rem',
    '1.5rem',
    '2rem',
    '3rem',
    '4rem',
    '6rem',
  ],
  fontFamily:
    'Source Sans Pro, -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
  headingsColor: th('gray1000'),
  headingsFontFamily:
    'Montserrat, -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
  headingsFontWeight: 700,
}
